export const getRecaptchaLanguageCode = (languageCode: string) => {
  switch (languageCode) {
    case 'ZH_HANS':
      return 'zh-CN';
    case 'ZH_HANT':
      return 'zh-TW';
    default:
      return languageCode;
  }
};
